import React from 'react';
import PropTypes from 'prop-types';
import '../assets/sass/components/checkbox.sass';

const CCCheckbox = ({
  lists,
  item,
  children,
  onChange,
  checked,
  callback,
  disabledCheckbox,
  ...rest
}) => {
  const toggleCheckbox = () => {
    if (item) {
      if (lists.includes(item)) {
        onChange(lists.filter(list => list !== item));
        callback();
        return;
      }
      onChange([...lists, item]);
      callback();
      return;
    }

    onChange(!checked);
    callback();
  };

  const checkIfActive = () => checked || lists.includes(item);

  return (
    <div
      {...rest}
      className={`checkbox-container ${rest.className || ''}`}
    >
      <input
         
        type="checkbox"
        defaultChecked={checkIfActive()}
        onChange={() => toggleCheckbox()}
        disabled={disabledCheckbox}
      />
      <i className={`material-icons ${checkIfActive() ? 'icon-active' : ''}`}>
        {
          checkIfActive()
            ? 'check_box'
            : 'check_box_outline_blank'
        }
      </i>
      {children}
    </div>
  );
};

CCCheckbox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  lists: PropTypes.instanceOf(Array),
  item: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  callback: PropTypes.func,
  disabledCheckbox: PropTypes.bool,
};

CCCheckbox.defaultProps = {
  lists: [],
  item: '',
  checked: false,
  callback: () => {},
  disabledCheckbox: false,
};

export default CCCheckbox;
